import get from 'lodash/get'
import { createUrl } from '../../../../localized-urls'
import RatingStars from '../../../helpers/RatingStars'
import { PropTypes } from 'prop-types'

BookingDetailsCardHeader.propTypes = {
  order: PropTypes.shape({
    shopKind: PropTypes.number.isRequired,
    shopLocationSlug: PropTypes.string.isRequired,
    shopSlug: PropTypes.string.isRequired,
    shopTitle: PropTypes.string.isRequired,
    shopLocationTitle: PropTypes.string.isRequired,
    numberOfReviews: PropTypes.number,
    rate: PropTypes.number,
    thumbnails: PropTypes.shape({
      DOSliderMobileLand: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

const shopPage = {
  10: 'la_page',
  20: 'dr_page',
}

function BookingDetailsCardHeader({ order }) {
  const { shopKind, shopLocationSlug, shopSlug } = order

  const shopUrl = shopKind
    ? createUrl(shopPage[shopKind], {
      slug: shopSlug,
      location: shopLocationSlug,
    })
    : '#'

  const imgUrl = get(order, 'thumbnails.DOSliderMobileLand')
  return (
    <div
      className='img'
      style={{
        backgroundImage: `url(${imgUrl})`,
      }}
    >
      <div className='info-pan'>
        <a href={shopUrl} target='_blank' className='shop-title'>
          {order.shopTitle}
        </a>
        {order.numberOfReviews > 3 && <RatingStars rating={order.rate} />}
        <p className='location'>
          <i className='location-icon' />
          {order.shopLocationTitle}
        </p>
      </div>
    </div>
  )
}

export default BookingDetailsCardHeader
